import { APP_HEADER_HEIGHT_VAR, HeaderContent, HEADER_TITLE_CLASS } from '../../../components/shell/app-header';
import { useParams } from '../../../lib/routing';
import { trouverParcours, urlFichier, OUTILS_ENSEIGNANT } from './parcours-config';

const MENTION_ELEVE: Record<'beta' | 'brouillon', string> = {
  beta: 'Contenu de la bêta — rien n’est enregistré.',
  brouillon: 'Brouillon, pas encore testé — rien n’est enregistré.',
};

export default function HoteIframe() {
  const { slug } = useParams<{ slug?: string }>();
  const parcours = trouverParcours(slug);

  if (!parcours) {
    return (
      <>
        <HeaderContent width="md" showBurger backTo="/mini-apps/francais-college" backLabel="Français collège">
          <h1 className={HEADER_TITLE_CLASS}>Parcours introuvable</h1>
        </HeaderContent>
        <p className="m-0 p-4 text-[color:var(--naia-text-secondary)]">Ce parcours n’existe pas.</p>
      </>
    );
  }

  const enseignant = OUTILS_ENSEIGNANT.some((o) => o.slug === parcours.slug);

  return (
    <>
      <HeaderContent width="md" showBurger backTo="/mini-apps/francais-college" backLabel="Français collège">
        <div className="min-w-0">
          <h1 className={HEADER_TITLE_CLASS}>{parcours.titre}</h1>
          <p className="m-0 mt-0.5 text-[13px] leading-snug text-[color:var(--naia-text-secondary)]">
            {enseignant ? 'Outil enseignant — rien n’est enregistré.' : MENTION_ELEVE[parcours.statut]}
          </p>
        </div>
      </HeaderContent>
      <iframe
        src={urlFichier(parcours)}
        title={parcours.titre}
        className="w-full border-0"
        style={{ height: `calc(100dvh - var(${APP_HEADER_HEIGHT_VAR}, 0px))` }}
        sandbox="allow-scripts allow-downloads"
      />
    </>
  );
}
